import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowNextSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4.414 5.586 8 2 11.586 3.414 13l5-5-5-5L2 4.414Zm5.586 0L11.172 8l-3.586 3.586L9 13l5-5-5-5-1.414 1.414Z"
    />
  </svg>
);
export default IconArrowNextSizeS;
